'use strict'; // http://www.ecma-international.org/ecma-262/5.1/#sec-9.3

module.exports = function ToNumber(value) {
  return +value; // eslint-disable-line no-implicit-coercion
};